import React, { createContext, useContext, useState, useEffect } from "react";
import { getMaintenanceStatus } from "../services/maintenanceService";

// Create the context
const MaintenanceContext = createContext();

export const useMaintenance = () => useContext(MaintenanceContext);

// Simulate the API call that fetches the maintenance state
const checkMaintenanceState = async () => {
  try {
    const response = await getMaintenanceStatus();
    // Return `true` if in maintenance mode; otherwise, `false`
    return response.data || false;
  } catch (error) {
    console.error("Error fetching deployment state", error);
    return false; // Return `false` for all other errors
  }
};

// Create the provider component
export const MaintenanceProvider = ({ children }) => {
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMaintenanceState = async () => {
      setIsLoading(true);
      const maintenanceStatus = await checkMaintenanceState();
      setIsUnderMaintenance(maintenanceStatus);
      setIsLoading(false);
    };

    fetchMaintenanceState();
  }, []);

  return (
    <MaintenanceContext.Provider value={{ isUnderMaintenance, isLoading }}>
      {children}
    </MaintenanceContext.Provider>
  );
};
